import { RefObject, createRef } from 'react';
import { InputType, SofaCheckbox, SofaInput, SofaRadio, SofaSelect } from '@sofology/sofologycomponents';
import { ComponentTypeDescription, PropertyDescriptionTypes } from 'models';
import { SofaFormAddressWrapper } from 'components/dynamicFormComponents';

export const createRefByComponentType = (inputType: InputType, property: PropertyDescriptionTypes): RefObject<any> => {
    if (property.componentType === ComponentTypeDescription.Address) {
        return createRef<SofaFormAddressWrapper>();
    }

    switch (inputType) {
        case InputType.DatePicker:
        case InputType.TextInput:
            return createRef<SofaInput>();
        case InputType.Radio:
            return createRef<SofaRadio>();
        case InputType.Selector:
            return createRef<SofaSelect>();
        case InputType.Checkbox:
            return createRef<SofaCheckbox>();
        default:
            return createRef<SofaInput>();
    }
};